import React, { useEffect, useState } from 'react';
import Details from './details';
import Course from './course';
import Loader from '../../layouts/loader';
import apiService from '../../../services/apiService'
import { LanguageProvider } from '../../shared/languageContext';
import Sidebar from '../../layouts/sidebar';

const LearningSpace = () => {
    const [userInfo, setUserInfo] = useState({});
    const [loader, setLoader] = useState(true);
    const [courseDetails, setCourseDetails] = useState([]);

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                let user = JSON.parse(sessionStorage.getItem("user_details"));
                if (user) {
                    setUserInfo(user);
                } else {
                    const token = apiService.getAuthToken()
                    const result = await apiService.get('get-org-user-info', token);
                    sessionStorage.setItem('user_details', JSON.stringify(result.data))
                    if (result && result.status == "success") {
                        setUserInfo(result.data);
                    }
                }
            } catch (error) {
                setLoader(false);
                console.error("Error fetching user details:", error);
            } finally {
                setLoader(false);
            }
        };

        fetchUserDetails();
    }, []);

    let userDetails = sessionStorage.getItem('userDetail')
    if (userDetails) {
        userDetails = JSON.parse(userDetails)
        console.log(userDetails?.org_id)
    }
    // console.log("userDetails :", userDetails);

    //console.log(Object.keys(userInfo).length)
    const shouldReloadDetails = !userInfo || Object.keys(userInfo).length == 0


    return (
        <>

            {loader ? <Loader /> :
                <div className='page__main' style={{ minHeight: '100vh' }}>
                    <div className="dashboard">
                        <div className='container-fluid'>
                            <div className="welcome-container mb-4 shadow-custom">
                                <div className="welcome-content">
                                    <h1 className="welcome-heading font-26">Welcome to Inclusional</h1>
                                    <p className="welcome-subheading">
                                        Let's learn, grow, and create <br className="d-block d-md-none" /> impact—together!
                                    </p>
                                    <p className="welcome-text small">
                                        We're excited to have you join us toward <br className="d-block d-md-none" /> building a more inclusive, safe, and  <span className="break-after">respectful <br className="d-block d-md-none" /> workplace</span> Through engaging content and <br className="d-block d-md-none" /> practical
                                        insights, our platform will empower <br className="d-block d-md-none" /> you to create meaningful change.
                                    </p>
                                </div>

                                <div className="d-none d-md-block" style={{ position: 'absolute', top: '12px', right: '20px', width: '279px', height: '149px', backgroundImage: `url("/images/welcome.svg")`, backgroundRepeat: 'no-repeat', backgroundPosition: '0% 0%', }}
                                />
                                <div className="d-block d-md-none text-center mt-4" style={{ position: 'absolute', top: '12px', right: '0px', left: '0px', width: '280px', height: '100px', margin: '20px auto 0' }}>
                                    <img
                                        src="/images/welcome.svg"
                                        alt="welcome"
                                        className="img-mobile"
                                    />
                                </div>
                            </div>
                            {userDetails && userDetails?.org_id != '7c13b617-55a1-4ea6-810a-7bf05aaf52af' ? ((userInfo?.gender && userInfo?.gender != "undefined") && (userInfo?.age_group && userInfo?.age_group != "undefined")) ? null : <Details userInfo={userInfo} /> : ' '}
                            {/* <Details userInfo={userInfo} /> */}
                            <Course />
                        </div>
                    </div>
                </div>
            }

        </>
    );
};

export default LearningSpace;